import { useStyle } from "@pages/Home/broadband/style";
import { HomeBroadbandResult } from "@features/home/broadband/HomeBroadbandResult";

export const HomeBroadbandResultPage = () => {
    const { classes } = useStyle();

    return (
        <div className={classes.broadbandPage}>
            <HomeBroadbandResult />
        </div>
    );
};
